module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_agder_pos.3309cdb5.svg";